import { AiOutlinePlus, AiOutlineClose } from 'react-icons/ai';

import { cme_kurs } from '../Global/Kurs'


// -- component to select users Interessensgebiete
const InteressensgebieteSelection = ({ thisUser, changeInterGebi, closePopup }) => {


    return (
        <div className='interessensgebiete-selection-container no-scrollbar'>
            {/* header */}
            <div className='interessensgebiete-selection-header'>
                <h5>Wählen Sie Ihre Interessensgebiete</h5>
                <input type="button" onClick={closePopup} className="my-small-btn" value="Weiter" />
            </div>

            {/* selection */}
            <div className="interessensgebiete-selection">

                {/* map interessensgebiete */}
                {cme_kurs.Interessensgebiete.map((elem, i) => {

                    // gebiet is selected
                    const isActive = thisUser.Interessensgebiete.includes(elem);

                    // use linebreaks to highlight alphabetic sorting
                    let useBreak = i === 0 ? true : false;
                    const lastElem = cme_kurs.Interessensgebiete[i - 1];
                    if (lastElem && elem.charAt(0) !== lastElem.charAt(0)) useBreak = true;

                    return (
                        <span key={`interessensgebiete-selection-key-${i}`}>
                            {useBreak ? <h5 className='alphabet-header'>{elem.charAt(0)}</h5> : ""}
                            <div className={`single-interessensgebiet ${isActive ? "active" : ""}`} onClick={() => changeInterGebi(elem)}>
                                {elem} {isActive ? <AiOutlineClose /> : <AiOutlinePlus />}
                            </div>
                        </span>
                    )
                })}
            </div>
        </div>
    )
}

export default InteressensgebieteSelection